import { Avatar, Card, message } from "antd";
import Button from "Components/Button";
import { useGetMeQuery } from "hooks/Auth/useGetMeQuery";
import DriverDashboard from "Layout/DriverDashboard";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";

const DriverProfile = () => {
  const { data } = useGetMeQuery();
  const navigate = useNavigate();

  return (
    <DriverDashboard back={false} title="Profile">
      <div className="flex justify-center mb-3">
        <Avatar
          style={{
            backgroundColor: "#562B00",
            verticalAlign: "middle",
          }}
          size={40}
        >
          {data?.data?.firstName && data?.data?.firstName.charAt(0)}
        </Avatar>
      </div>
      <p className="text-center">
        {data?.data?.firstName + " " + data?.data?.lastName}
      </p>
      <p className="text-center text-[#A8A8A8] text-[12px] pb-[20px]">
        Driver ID:
        {data?.data?.id}
      </p>
      <Card className="mb-4">
        <Section
          title={"First Name"}
          value={<span>{data?.data?.firstName}</span>}
        />
        <Section
          title={"Last Name"}
          value={<span>{data?.data?.lastName}</span>}
        />
        <Section title={"Email"} value={<span>{data?.data?.email}</span>} />
        <Section
          title={"Phone Number"}
          value={<span>{data?.data?.phoneNumber}</span>}
        />
        <Section
          title={"Rep Code"}
          value={<span>{data?.data?.repCode}</span>}
        />
        <Section
          title={"Created At"}
          value={
            <Moment interval={0} format="DD-MM-YYYY hh:mm a">
              {data?.data?.createdAt}
            </Moment>
          }
        />
        <Section
          title={"Last Login"}
          value={
            <Moment interval={0} format="DD-MM-YYYY hh:mm a">
              {data?.data?.lastLogin}
            </Moment>
          }
        />
      </Card>
      <Button
        label="Logout"
        onClick={() => {
          navigate("/");
          localStorage.clear();
          message.success("Logout successful");
        }}
      />
    </DriverDashboard>
  );
};

export default DriverProfile;

const Section = ({ title, value }: { title: string; value: unknown }) => {
  return (
    <div className="flex gap-2 py-[10px]">
      <span className="w-4/12 text-[#A8A8A8]">{title}</span>
      <span className="w-8/12">{value as React.ReactNode}</span>
    </div>
  );
};
